import React, { useEffect, useState } from "react";

import AdminHeader from "../../AdminComponents/AdminHeader/AdminHeader";

import SideBarAdmin from "../../AdminComponents/SideBarAdmin/SideBarAdmin";
// import AddVehicleDrawer from "./AddVehicleDrawer";
// import TableDateAdminVehicle from "./TableDateAdminVehicle";
// import "./VehiclesAdmin.css";
import './ProfileDriver.css'
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addVehicle } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";
import DriverHeader from "../DiverHeader/DiverHeader";
import { updateDriver } from "../../redux/AdminReducer";
import { getAllDrivers } from "../../redux/AdminReducer";
import SideBarDriver from "../SideBarDriver/SideBarDriver";

const ProfileDriver = () => {
  const [rightHeader, setRightHeader] = useState(false);

  const dispatch = useDispatch();

  // const currentUser=useSelector((state)=>state?.CustomerReducer?.currentCustomer?.user);
  const currentUser=useSelector((state)=>state?.DriverReducer?.currentDriver?.user);
  const driversData = useSelector(
    (state) => state?.AdminReducer?.getAllDriversData
  );

  console.log("currentDriver",driversData,currentUser)

const navigate=useNavigate();

  const[vehicle,setUser]=useState(
      {
          email:currentUser?.email,
          name:currentUser?.name,
          phone:currentUser?.phone,
          address:currentUser?.address,
          password:"",
          userType:"Customer"
      }
  )

  const handleChange=(e)=>{

      const{name,value}=e.target

      setUser(
          {
              ...vehicle,[name]:value
          }
      )
  }

  console.log("user",vehicle)

  const signupClicked=async()=>{

      let id=currentUser._id;
      let idData={
          id:currentUser._id
      }
      console.log("idClicked",id,vehicle,driversData)
   
    const response=await dispatch(updateDriver({id,vehicle,driversData}))


    console.log("response",response?.payload?.data?.message)
    console.log("response",response?.payload.message)

    Swal.fire(
      'Good',
      response?.payload.message,
      'success'
    )


    //   if(response?.payload?.success)
    //   {

      //   navigate("/customer/login")
    //   }


  }

  useEffect(()=>{

    dispatch(getAllDrivers())

  },[])


  return (
    <>
      {/* <AdminHeader rightHeader={rightHeader} /> */}

      <DriverHeader rightHeader={rightHeader} />

      <div className="topSideVehicles">
        {/* <SideBarAdmin
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        /> */}

        <SideBarDriver
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        />
       <div className="mainContainerLogin mainContainerSignup mainContainerProfile 
       mainContainerProfileDriver
       ">
      <div className="userLoginTxt userLoginTxtProfile">You can edit your profile here..</div>

      <div className="topRowFieldsSignup topRowFieldsSignupProfile">
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile" >
          <div className="inputTxtLogin">Email</div>
          <input
            className="inputLogins inputSignup"
            type="email"
            placeholder="Enter Email"
            value={vehicle.email}

            onChange={handleChange}
            name="email"
          />
        </div>
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile">
          <div className="inputTxtLogin">Name</div>
          <input
            className="inputLogins inputSignup"
            type="text"
            placeholder="Enter Name"
            value={vehicle.name}

            onChange={handleChange}
            name="name"
          />
        </div>
      </div>
      <div className="topRowFieldsSignup topRowFieldsSignupProfile">
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile">
          <div className="inputTxtLogin">Mobile Number</div>
          <input
            className="inputLogins inputSignup"
            // type="number"
            placeholder="Enter Mobile Number"
            value={vehicle.phone}
            onChange={handleChange}
     
            name="phone"
          />
        </div>
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile">
          <div className="inputTxtLogin">Address</div>
          <input
            className="inputLogins inputSignup"
            // type="number"
            placeholder="Enter Address"
            value={vehicle.address}
            onChange={handleChange}
     
            name="phone"
          />
        </div>
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile">
          <div className="inputTxtLogin"
          type="password"
          
          >Password</div>
          <input
            className="inputLogins inputSignup"
            type="password"
            placeholder="Enter Password"
            onChange={handleChange}
            name="password"
          />
        </div>
      </div>


      <button className="loginBtn saveBtnProfile"
      onClick={signupClicked}
      >Save</button>

    
    </div>
      </div>
    </>
  );
};

export default ProfileDriver;
